import React, { useState } from 'react';
import { manipulateNodes } from '@helpers/jqueryHelpers';
import { RelatedItemTag } from '@layouts/Related/Related.types';

interface RelatedFilterProps {
  onTagClick: (tag: RelatedItemTag) => void;
  contentType: string;
  tags: RelatedItemTag[];
  isBound: boolean;
  i18n: Record<string, string>;
  className: string;
}

export const RelatedFilter = ({
  onTagClick = () => {},
  contentType,
  tags = [],
  isBound,
  i18n,
  className,
}: RelatedFilterProps) => {
  const [selectedTag, setSelectedTag] = useState<RelatedItemTag>({ id: 0, name: 'All' });

  const onTagClickHandler = (tag: RelatedItemTag) => {
    manipulateNodes(`.related-block-${contentType}`, (node) => node.classList.add('hidden'));

    setSelectedTag(tag);
    onTagClick(tag);
  };

  const renderTag = (tag: RelatedItemTag) => {
    const isActive = tag.id === selectedTag.id ? 'c-filter-block-tag-is-active' : '';

    return (
      <span
        key={tag.id}
        onClick={() => onTagClickHandler(tag)}
        className={`c-filter-block-tag ${isActive}`}
      >
        {tag.name}
      </span>
    );
  };

  return tags.length > 0 ? (
    <div className={`c-filter-block ${className}`}>
      <div className={isBound ? 'is-bound' : ''}>
        {renderTag({ id: 0, name: i18n.All })}
        {tags.map(renderTag)}
      </div>
    </div>
  ) : null;
};
